import { render, staticRenderFns } from "./Rhizography.vue?vue&type=template&id=4db49534&scoped=true&"
import script from "./Rhizography.vue?vue&type=script&lang=js&"
export * from "./Rhizography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db49534",
  null
  
)

export default component.exports